import { Component, ComponentFactoryResolver, Injector, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Action, CrudEditComponent, CrudEditorParentService, CrudEditorSelfService, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { AmmunitionStock } from 'assets-model';
import { AmmunitionStockItemComponent } from './ammunition-stock-item.component';
import { AMMUNITION_STOCK_EVENT_TYPE } from 'assets-model';
import { openJustfoneDataTransferDialog } from '../../datatransfer/dialog/justfone-data-transfer-dialog.component';


@Component({
  selector: 'app-ammunition-stock-editor',
  templateUrl: '../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.html',
  styleUrls: ['../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.css'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class AmmunitionStockEditorComponent extends CrudEditComponent<AmmunitionStock, number> implements OnInit {


  get ammunitionStockItemComponent(): AmmunitionStockItemComponent {
    return <AmmunitionStockItemComponent>this.itemComponent;
  }

  constructor(
    route: ActivatedRoute,
    router: Router,
    userStorage: UserStorage,
    dialog: MatDialog,
    snackbar: MatSnackBar,
    componentFactoryResolver: ComponentFactoryResolver,
    injector: Injector,
    private formStorage: FormStorage) {
    super(route, router, userStorage, dialog, snackbar, componentFactoryResolver, injector);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  itemSet() {
    super.itemSet();
    const self = this;
    this.actions = [];
    this.actions.push(<Action>{
      title: 'Stocktake',
      get enabled(): boolean {
        return true;
      },
      color: 'accent2',
      get available(): boolean {
        return !self.createMode && !self.item.closed;
      },
      doAction() {
        self.ammunitionStockItemComponent.navigateToStocktake();
      }
    });
    this.actions.push(<Action>{
      title: 'Additions',
      get enabled(): boolean {
        return self.item?.hasStocktake;
      },
      color: 'accent2',
      get available(): boolean {
        return !self.createMode && !self.item.closed;
      },
      doAction() {
        self.ammunitionStockItemComponent.navigateToAddition();
      }
    });
    this.actions.push(<Action>{
      title: 'Issue',
      get enabled(): boolean {
        return self.item?.hasStocktake;
      },
      color: 'accent2',
      get available(): boolean {
        return !self.createMode  && !self.item.closed;
      },
      doAction() {
        self.ammunitionStockItemComponent.navigateToIssue();
      }
    });
    this.actions.push(<Action>{
      title: 'Return',
      get enabled(): boolean {
        return self.item?.hasStocktake;
      },
      color: 'accent2',
      get available(): boolean {
        return !self.createMode  && !self.item.closed;
      },
      doAction() {
        self.ammunitionStockItemComponent.navigateToReturn();
      }
    });
    this.actions.push(<Action>{
      title: 'Full Stock History',
      get enabled(): boolean {
        return self.item?.hasStocktake;
      },
      color: 'primary',
      get available(): boolean {
        return !self.createMode;
      },
      get route() {
        return [...AMMUNITION_STOCK_EVENT_TYPE.historyRouteBase, self.item?.ammunitionStockId]
      },
      getQueryParams() {
        return {};
      }
    });
    this.actions.push(<Action>{
      title: 'Justfone Debug',
      get enabled(): boolean { return !self.unsavedChanges() },
      color: "primary",
      get available(): boolean {
        return self.currentUserHasAnyAuthority("IS_SUPERUSER");
      },
      doAction() {
        openJustfoneDataTransferDialog(self.dialog, 'AmmunitionStock', self.item.ammunitionStockId);
      }
    });
  }


}






